module.exports = __webpack_public_path__ + "./images/valoracion.5be8248f44cc075a08f32f8f17d68309.png";


//////////////////
// WEBPACK FOOTER
// ./websources/public/images/valoracion.png
// module id = ./websources/public/images/valoracion.png
// module chunks = 0